import styled from "styled-components";

export const BreadcrumbWrapper = styled.div`
  position: absolute;
  top: 0;
  height: 61px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.default[100]};`};
  ${({ theme }) => theme.breakpoints.md.query} {
    height: fit-content;
    min-height: 48px;
    flex-direction: column;
  }
`;

export const BreadcrumbsContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: ${(props) => props.theme.content.maxWidth}px;
  display: flex;
  justify-content: flex-start;
  padding: 0px 12px;
  ${({ theme }) => theme.breakpoints.md.query} {
    flex-direction: column-reverse;
    padding: 12px 24px;
    gap: 10px;
  }
`;

export const Breadcrumbs = styled.div`
  display: flex;
`;

export const Breadcrumb = styled.div<{ $mobileShortcut?: boolean }>`
  display: flex;
  align-items: center;
  width: fit-content;
  // overflow: ${({ $mobileShortcut }) =>
            $mobileShortcut ? "revert" : "hidden"};
  p {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  > a {
    display: flex;
    gap: 4px;
    align-items: center;
    overflow: hidden;
  }

  > div {
    display: flex;
    gap: 4px;
    align-items: center;
    overflow: hidden;
  }

  span {
    display: none;
  }

  ${({ theme }) => theme.breakpoints.md.query} {
    p {
      display: ${({ $mobileShortcut }) => ($mobileShortcut ? "none" : "block")};
    }

    span {
      display: ${({ $mobileShortcut }) => ($mobileShortcut ? "block" : "none")};
    }
  }
`;

export const BreadcrumbComponent = styled.div`
  align-self: center;
  margin-left: auto;

  ${({ theme }) => theme.breakpoints.md.query} {
    margin-right: auto;
    margin-left: 0;
    padding-top: 12px;
  }
`;
